import { useEffect, useState } from "react";
import { Box, Card, CardBody, CardHeader, Container, Heading, Image, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BottomOfPageContactUs } from "../BottomOfPageContactUs";
import { YouTubeEmbed } from "./YouTubeEmbed";
import { useCmsApi } from "../../services/useCmsApi";

const DEFAULT_VIDEO_ID = "apqSjsVa0VY";

export const HerbicideResistanceDetails = (): JSX.Element => {
	const { t } = useTranslation();
	const [videoId, setVideoId] = useState(DEFAULT_VIDEO_ID);
	const cmsApi = useCmsApi();

	useEffect(() => {
		cmsApi.getSiteSetting("herbicideResistanceVideoId").then((setting) => {
			if (setting?.value) setVideoId(setting.value);
		});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Container maxW="1480px" py={{ base: "12", md: "12" }}>
			<Card>
				<CardHeader>
					<Heading size="sm">{t("herbResist.detail1Title")}</Heading>
				</CardHeader>
				<CardBody>
					<Text>{t("herbResist.detail1")}</Text>
					<Box p="2" boxShadow="lg" borderRadius="xl" overflow="hidden">
						<Image
							w="full"
							maxW="100%"
							mx="auto"
							display="block"
							src="/weed-prediction-vs-actual.png"
							alt={t("herbResist.scoutAlt") || "Herbicide Resistance Scouting"}
						/>
					</Box>
				</CardBody>
			</Card>

			<Card mt="2em">
				<CardHeader>
					<Heading size="sm">{t("herbResist.detail2Title")}</Heading>
				</CardHeader>
				<CardBody>
					<Text>{t("herbResist.detail2")}</Text>
					<Box borderWidth="1px" borderRadius="xl" p="2" boxShadow="lg" overflow="hidden">
						<Image
							w="full"
							maxW="100%"
							mx="auto"
							display="block"
							src="/weed-prediction-backcast.png"
							alt={t("herbResist.resistScoutAlt") || "Herbicide Resistance Scouting"}
						/>
					</Box>
					<Text mt="1.5em">{t("herbResist.videoDemoText")}</Text>

					<YouTubeEmbed src={`https://www.youtube-nocookie.com/embed/${videoId}`} title={t("herbResist.videoDemoText") || undefined} center />
				</CardBody>
			</Card>

			<BottomOfPageContactUs />

		</Container>
	);
};
